export const datadogConfig: Record<string, string> = {
  version: '1.0.0',
  APPLICATION_ID: '6259b87a-8966-44f4-be53-b0386012610e',
  CLIENT_TOKEN: 'pube9d5f369526f6e189829742c9f743daf',
};
